import { NgModule } from '@angular/core';
import { UChipsComponent } from './u-chips.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { UiInfraModule } from '../../ui-infra.module';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UButtonModule } from '../u-button/u-button.module';
import { UIconModule } from '../u-icon/u-icon.module';

@NgModule({
  declarations: [UChipsComponent],
  imports: [
    MatChipsModule,
    MatIconModule,
    MatFormFieldModule,
    FormsModule,
    CommonModule,
    TooltipModule,
    UiInfraModule,
    UButtonModule,
    UIconModule,
  ],
  exports: [UChipsComponent],
})
export class UChipsModule {}
